import { useChatHistory } from 'src/hooks';
import { ConversationsList } from '../../../ConversationsList/ConversationsList';
import styles from './ConversationListSection.module.scss';
import { ConversationFooter } from './components/ConversationFooter';
import { FilterToolbar } from './components/FilterToolbar';
import { UpsellFooter } from './components/UpsellFooter';

// TODO(olha): move to V2
export const ConversationListSection = () => {
  const { isNinjaRetired } = useChatHistory();
  return (
    <div className={styles.root} data-testid="first-panel">
      <FilterToolbar />

      <ConversationsList />

      {!isNinjaRetired && <UpsellFooter />}

      <ConversationFooter />
    </div>
  );
};
